import BolideAssistantButton from "@/components/BolideAssistantButton/BolideAssistantButton.vue";
import PlatformSwitcher from "@/components/PlatformSwitcher/PlatformSwitcher.vue";

export default {
  name: "HeaderSection",

  components: {
    BolideAssistantButton,
    PlatformSwitcher
  },

  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    }
  },

  emits: [
    "breadcrumb-click",
    "open-assistant",
    "toggle-mobile-sidebar"
  ],

  data() {
    return ({
      is_mobile: window.innerWidth < 768
    });
  },

  mounted() {
    window.addEventListener("resize", this.handle_resize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handle_resize);
  },

  methods: {
    handle_resize() {
      this.is_mobile = window.innerWidth < 768;
    },

    openAssistant() {
      this.$emit("open-assistant");
    }
  }
};
